import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SearchQueryState } from './search-query.reducer';

export const getSearchQueryState = createFeatureSelector<SearchQueryState>('search_query');

export const getSearchQuery = createSelector(
  getSearchQueryState,
  (state) => state.entity
);
